import { deliveryPartnerActionSelectors as selector } from "../Selectors/index";

export const deliverPartnerReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET:
      return payload;

    default:
      return state;
  }
};


